import { memo, type FC } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

type ErrorStateProps = {
  error: string | null;
  onRetry: () => void;
};

export const ErrorState: FC<ErrorStateProps> = memo(({ error, onRetry }) => {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Alert severity="error" sx={{ mb: 2 }}>
        {error || "An error occurred"}
      </Alert>
      <Button variant="outlined" size="small" fullWidth onClick={onRetry}>
        Try Again
      </Button>
    </Box>
  );
});

ErrorState.displayName = "ErrorState";
